import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LandingPageConfigDto } from './landing-page-config.model';

@Injectable({ providedIn: 'root' })
export class LandingPageConfigService {

  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getConfig(salesOrganization: string, language: string): Observable<LandingPageConfigDto> {
    const url = `${this.apiUrl}/landing-page-config?salesOrganization=${salesOrganization}&language=${language}`;
    return this.http.get<LandingPageConfigDto>(url);
  }

  // Fallback for products without a resolved sales organization (e.g. showroom units on the not-sold page).
  getConfigForCountry(country: string, language: string): Observable<LandingPageConfigDto> {
    const url = `${this.apiUrl}/landing-page-config?country=${country}&language=${language}`;
    return this.http.get<LandingPageConfigDto>(url);
  }

  getWhitelabelConfig(): Observable<LandingPageConfigDto> {
    return this.http.get<LandingPageConfigDto>(`${this.apiUrl}/landing-page-config/whitelabel`);
  }
}
